import { render } from "./TextInputWithLabel.vue?vue&type=template&id=a51b4ed2"
import script from "./TextInputWithLabel.vue?vue&type=script&lang=js"
export * from "./TextInputWithLabel.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/LCAP/LCAP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__